import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M245.8 214.9L212.6 232.2C203.2 212.6 187.4 212.2 185.2 212.2 163 212.2 151.9 226.8 151.9 256.1 151.9 279.6 161.1 299.9 185.2 299.9 199.6 299.9 209.8 292.8 215.7 278.6L246.3 294.1C240.1 305.6 220.6 333.1 181.2 333.1 158.6 333.1 107.2 322.8 107.2 256.1 107.2 197.4 150.2 179 179.8 179 210.6 179 232.5 191 245.8 214.9zM388.9 214.9L356.1 232.2C346.6 212.4 330.4 212.2 328.2 212.2 306.1 212.2 295 226.8 295 256.1 295 279.6 304.2 299.9 328.2 299.9 342.7 299.9 352.9 292.8 358.7 278.6L389.7 294.1C387.6 297.9 368.4 333.1 324.7 333.1 302 333.1 250.7 323.3 250.7 256.1 250.7 197.4 293.7 179 323.3 179 354 179 375.9 191 388.9 214.9zM247.6 8.1C104.7 8.1 0 123.1 0 256.1 0 394.5 113.6 504.1 247.6 504.1 377.5 504.1 496 403.2 496 256.1 496 118.2 389.4 8.1 247.6 8.1zM248.4 458.9C135.9 458.9 44.7 365.8 44.7 256.1 44.7 150.6 130.2 52.8 248.4 52.8 361 52.8 451.3 142.2 451.3 256 451.3 377.7 351.6 458.9 248.4 458.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons.js
// module id = J4Fn
// module chunks = 144